/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ColStyled,
  ContainerStyled,
  DivStyledBackgroundContainer,
  LinkStyledButton,
  RowStyled,
  SectionStyled,
  TypographyStyledHeading,
  TypographyStyledHighlight,
  TypographyStyledSubheading,
} from './styles';

export default () => {

  const theme = useContext(ThemeContext);
  const isLargeUp = theme.largeUp();

  return (
    <SectionStyled
      id='section-home-hero'
      disableBottomPadding
      role='banner'>
      <DivStyledBackgroundContainer />
      <ContainerStyled>
        <RowStyled>
          <ColStyled medium={7}>
            <TypographyStyledHeading
              id='section-home-hero-heading-text'
              component='h1'
              ariaLabel='Go from stress to yes.'
              typeface='serif'
              disableBottomPadding>
              <TypographyStyledHighlight
                id='section-home-hero-heading-highlight'
                component='span'
                typeface='handwritten'
                block
                disableBottomPadding>
                Welcome to
              </TypographyStyledHighlight>
              A better way <WidowBlock>to money<sup className='nmx-sup'>&#8482;</sup></WidowBlock>
            </TypographyStyledHeading>
            <TypographyStyledSubheading
              id='section-home-hero-sub-heading'
              variant={isLargeUp ? 'h3' : 'h5'}
              weight={300}
              disableBottomPadding>
              See the difference the right <WidowBlock>advisor makes.</WidowBlock>
            </TypographyStyledSubheading>
            <LinkStyledButton
              id='home-hero-fa-cta'
              linkUrl='/find-a-financial-advisor/'
              variant='buttonLinkPrimary'
              themeType='darkTheme'
              ariaLabel='Get started with a financial professional.'>
              Let&#39;s get started
            </LinkStyledButton>
          </ColStyled>
        </RowStyled>
      </ContainerStyled>
    </SectionStyled>
  );
};
